import type { QueryFn } from '@percent/workplace-giving/common/hooks/useQuery/useQuery.types'
import type { GetGivingActionLogEventsQuery, GetGivingActionLogEventsResponse } from './getGivingActionLogEvents.types'

export const getGivingActionLogEvents: QueryFn<
  [string, GetGivingActionLogEventsQuery],
  GetGivingActionLogEventsResponse
> = async (client, [_, { actionId, targetType, targetId }]) =>
  (
    await client.get<GetGivingActionLogEventsResponse>(`v1/account/giving-actions/${actionId}/log-events`, {
      params: {
        targetType,
        targetId
      },
      withCredentials: true
    })
  ).data
